import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBottombarHiddenBottomWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bottombar-hidden-bottom-wide"><path d="M2.75 4.75H21.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M18 15.25L6 15.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBottombarHiddenBottomWide;
